var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tg-btnbacktotop",attrs:{"id":"tg-btnbacktotop","href":"javascript:;"},on:{"click":_vm.backToTop}},[_c('i',{staticClass:"icon-chevron-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }